import '../styles/main.scss';

// import external dependencies
import $ from 'jquery';

// Import Bootstrap JS
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import shop from './routes/shop';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Shop Page
  shop,
});

// Load Events
$(() => routes.loadEvents());
